<template>
    <div class="child">
        <el-form label-width="90px" ref="formData" :model="formData">
            <!-- 个人信息 -->
            <info :formData="formData" :index="1"></info>
            <!-- 既往病史 -->
            <illness :formData="formData" :index="1"></illness>
            <h5>治疗意见</h5>
            <div class="card">
                <el-form-item label="微针">
                    <el-checkbox-group @change="testSX" v-model="formData.treatmentOpinions">
                        <el-checkbox v-for="(item,index) in losts" :key="index" :label="item.id">
                            <span>{{item.name}}</span>
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="其他" class="double">
                    <el-input v-model.trim="formData.opinionsOther" style="width:95%;" placeholder="请输入其他诊断"></el-input>
                </el-form-item>
            </div>
            <h5>治疗纪录</h5>
            <div class="card">
                <el-form-item label="1.麻醉方式" label-width="140px">
                    <el-radio-group v-model="formData.anaesthesiaMode">
                        <el-radio :label="1">利多卡因乳膏表麻</el-radio>
                        <el-radio :label="0">无</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="2.治疗部位" label-width="140px">
                    <el-checkbox-group v-model="formData.treatmentPosition" @change="testSX">
                        <el-checkbox v-for="(item,index) in loads" :key="index" :label="item.id">
                            <span>{{item.name}}</span>
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="其他" class="double" label-width="140px">
                    <el-input v-model.trim="formData.positionOther" style="width:95%;" placeholder="请输入其他诊断"></el-input>
                </el-form-item>
                <el-form-item label="3.治疗步骤" label-width="140px">
                    <span>①清洁</span>
                    <span>②备皮</span>
                    <span>③治疗</span>
                    <span>④湿敷</span>
                </el-form-item>
                <el-form-item label="其他" class="double" label-width="140px">
                    <el-input v-model.trim="formData.stepOther" style="width:95%;" placeholder="请输入其他诊断"></el-input>
                </el-form-item>
                <el-form-item label="4.治疗后反应及处理" label-width="140px">
                    <div>①治疗后24小时内避触水及高温环境</div>
                    <div>②治疗后日常常需注意防晒保湿，避免日光暴晒</div>
                    <div>③治疗后一周内禁烟禁酒，尽量避免食用辛辣刺激的食物及海鲜</div>
                    <div>④治疗后5天内尽量避免桑拿或剧烈运动</div>
                    <div>⑤因个体不同，治疗效果会有所差异，建议疗程治疗</div>
                    <div>⑥其他 <span class="little">
                            <el-input v-model.trim="formData.treatmentOther" placeholder="请输入"></el-input>
                        </span>
                    </div>
                    <div>⑦随访</div>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer partFooter">
            <el-button type="danger" @click="close">取 消</el-button>
            <el-button type="primary" @click="doAddgoods()">确 定</el-button>
        </div>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import illness from './illness.vue'
import info from './info.vue'
export default {
    props: ['formData'],
    components: {
        illness, info
    },
    computed: {
        ...mapState(['losts', 'loads']),
    },
    data() {
        return {
            name: '',
        }
    },
    methods: {
        testSX() {
            this.$forceUpdate()
        },
        close() {
            this.$emit('close')
        },
        doAddgoods() {
            console.log(this.formData);
            let querys = {
                "id": "",
                musInformationId: this.formData.id,
                createBy: Lockr.get('skinEmpId'),
                treatmentTime: this.formData.sknDate,
                patientName: this.formData.patientName,
                sex: this.formData.sex,
                age: this.formData.age,
                caseCode: this.formData.caseCode,
                earId: this.formData.earId,
                earName: this.formData.earName,
                doctorName: this.formData.doctorName,
                doctorNo: this.formData.doctorNo,
                chiefComplaint: this.formData.mesoderm.chiefComplaint,
                latestMedicalHistory: this.formData.mesoderm.latestMedicalHistory,
                skinDisease: this.formData.skinDisease,
                diabetes: this.formData.diabetes,
                autoimmuneDisease: this.formData.autoimmuneDisease,
                coagulationDisorders: this.formData.coagulationDisorders,
                allergyHistory: this.formData.allergyHistory,
                preparationPregnant: this.formData.preparationPregnant,
                physicalExamination: this.formData.mesoderm.physicalExamination,
                diagnosisName: this.formData.diagnosisName,
                diagnosisNo: this.formData.diagnosisNo.toString(),
                diagnosisOther: this.formData.mesoderm.diagnosisOther,
                treatmentOpinions: this.formData.treatmentOpinions.toString(),
                opinionsOther: this.formData.opinionsOther,
                anaesthesiaMode: this.formData.anaesthesiaMode,
                treatmentPosition: this.formData.treatmentPosition.toString(),
                positionOther: this.formData.positionOther,
                stepOther: this.formData.stepOther,
                treatmentOther: this.formData.treatmentOther,
                medicalHistoryOther: this.formData.medicalHistoryOther,
                cadCode: this.formData.cadCode,
                musProjectId: this.formData.musProjectId,
                musProjectName: this.formData.musProjectName,
                sknFloor: this.formData.sknFloor,
            }
            api.requestQuiet("/case/createSknCaseMesoderm", querys, (res) => {
                if (res.result == true) {
                    this.$emit('close')
                    _g.toast("success", '添加成功');
                    this.query(this.filters.pagination.page)
                } else {
                    _g.toast("error", res.errMsg);
                }
            }, (err) => { });

        },
    }
}
</script>
<style scoped>
.card >>> .el-select .el-input__inner {
  width: 170px;
  height: 30px;
  line-height: 30px;
}
.double >>> .el-input__inner {
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.card >>> .el-form-item__label {
  line-height: 30px;
}
.card >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 170px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}
.child >>> .el-form-item {
  margin-bottom: 3px !important;
}
.card >>> .el-input__icon {
  line-height: 30px;
}
.card >>> .el-button i {
  margin: 0 !important;
}
.card >>> .el-button--mini {
  margin-top: 5px;
}
.card {
  background: #e0e6f0;
  border-radius: 10px;
  margin-bottom: 10px;
  padding-top: 5px;
  box-sizing: border-box;
}
.little >>> .el-input {
  width: 170px;
  /* height: 30px !important; */
  line-height: 30px;
  font-size: 12px;
}
.little >>> .el-input__inner {
  height: 30px;
}
</style>


